export default process.env.SYSTEM_CONFIG
    ? process.env.SYSTEM_CONFIG.parsed
    : {};
